/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
import React from 'react';
import * as Sentry from '@sentry/react';
import { Box, Typography, Button, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("ErrorBoundary caught an error", error, errorInfo);
    // Report to Sentry — error boundaries catch React rendering errors
    // before they reach window.onerror, so we must report explicitly
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo?.componentStack } } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ padding: '20px', textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Something went wrong.
          </Typography>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            {this.state.error?.toString()}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
            sx={{ marginTop: '20px' }}
          >
            Reload
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}


export default AppErrorBoundary;
